var React = require('react');

function HandHoldingSeedling (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M564 377L412.8 498a64.08 64.08 0 0 1-40 14H16a16 16 0 0 1-16-16v-96a16 16 0 0 1 16-16h55.4l46.5-37.7A117.69 117.69 0 0 1 192 320h160a32 32 0 0 1 31.6 37.4c-2.6 15.7-17.4 26.6-33.3 26.6H272a16 16 0 0 0 0 32h118.3a63.67 63.67 0 0 0 40-14l92.4-73.9c12.4-10 30.8-10.7 42.6 0A32 32 0 0 1 564 377z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M160 0H96a160 160 0 0 0 160 160v112a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160A160 160 0 0 0 160 0zm256 0c-40.7 0-77.5 15.7-105.8 40.8a190.94 190.94 0 0 1 41.6 116C424.9 142 480 77.5 480 0z","className":"fa-primary","key":2})]);
}

HandHoldingSeedling.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = HandHoldingSeedling;

HandHoldingSeedling.default = HandHoldingSeedling;
